export default "__VITE_ASSET__a1bca276__"